import gasanzeCover from "../assets/images/projects/eugene-gasanze/1.jpg";
import gasanzeImg1 from "../assets/images/projects/eugene-gasanze/2.jpg";
import gasanzeImg2 from "../assets/images/projects/eugene-gasanze/3.jpg";
import gasanzeImg3 from "../assets/images/projects/eugene-gasanze/4.jpg";

import kanombeCover from "../assets/images/projects/eugene-kanombe/1.jpg";
import kanombeImg1 from "../assets/images/projects/eugene-kanombe/2.jpg";
import kanombeImg2 from "../assets/images/projects/eugene-kanombe/3.jpg";
import kanombeImg3 from "../assets/images/projects/eugene-kanombe/4.jpg";

import biremboCover from "../assets/images/projects/birembo/1.jpg";
import biremboImg1 from "../assets/images/projects/birembo/2.jpg";
import biremboImg2 from "../assets/images/projects/birembo/3.jpg";
import biremboImg3 from "../assets/images/projects/birembo/4.jpg";

import muyaCover from "../assets/images/projects/muya-apartment/1.jpg";
import muyaImg1 from "../assets/images/projects/muya-apartment/2.jpg";
import muyaImg2 from "../assets/images/projects/muya-apartment/3.jpg";
import muyaImg3 from "../assets/images/projects/muya-apartment/4.jpg";

import kanombe2Cover from "../assets/images/projects/kanombe/Kanombe1.jpg";
import kanombe2Img1 from "../assets/images/projects/kanombe/Kanombe2.jpg";
import kanombe2Img2 from "../assets/images/projects/kanombe/Kanombe3.jpg";
import kanombe2Img3 from "../assets/images/projects/kanombe/Kanombe4.jpg";
import kanombe2Img4 from "../assets/images/projects/kanombe/Kanombe5.jpg";
import kanombe2Img5 from "../assets/images/projects/kanombe/Kanombe6.jpg";

export const projects = [
  {
    slug: 'gasanze-residential-homes',
    title: 'Gasanze Residential Homes',
    category: 'Residential',
    status: 'Completed',
    date: 'May 2024',
    duration: '10 Months',
    location: 'Gasanze, Kigali, Rwanda',

    // HERO
    coverImage: gasanzeCover,

    // GALLERY (IMPORTANT)
    images: [
      gasanzeImg1,
      gasanzeImg2,
      gasanzeImg3,
    ],

    // OVERVIEW
    shortDescription:
      'A modern residential housing project designed with sustainability, comfort, and efficient space utilization in mind.',

    description:
      'Gasanze Residential Homes is a thoughtfully planned housing development consisting of five modern residential units. The project emphasizes sustainable materials, energy efficiency, and contemporary architectural aesthetics while ensuring comfort and durability for residents.',

    // PROJECT INFO
    client: 'Private Developer',
    servicesProvided: [
      'Architectural Design',
      'Structural Engineering',
      'MEP Design',
      'Construction Supervision',
    ],

    area: '2,800 m²',
    budget: 'Confidential',

    // KEY FEATURES
    highlights: [
      'Modern design with sustainable materials',
      'Five residential housing units',
      'Integrated rainwater harvesting system',
      'Solar-powered lighting and heating',
      'Natural ventilation and daylight optimization',
    ],

    // TECHNICAL DETAILS
    specifications: [
      { label: 'Structure', value: 'Reinforced concrete' },
      { label: 'Floors', value: 'Ground + 1' },
      { label: 'Roofing', value: 'Insulated metal sheets' },
      { label: 'Energy', value: 'Solar-assisted systems' },
    ],

    // OPTIONAL
    challenges:
      'Site slope and drainage constraints required innovative foundation and water management solutions.',

    solutions:
      'Advanced site analysis and structural optimization ensured long-term stability and efficient water flow.',

    // SEO
    seo: {
      title: 'Gasanze Residential Homes | Edges Design Group',
      description:
        'Modern residential housing project in Gasanze, Kigali featuring sustainable design, solar systems, and contemporary architecture.',
    },
  },

  {
    slug: 'kanombe-eco-apartments',
    title: 'Kanombe Eco Apartments',
    category: 'Residential / Apartments',
    status: 'Completed',
    date: 'February 2023',
    duration: '14 Months',
    location: 'Kanombe, Kigali, Rwanda',

    coverImage: kanombeCover,
    images: [
      kanombeImg1,
      kanombeImg2,
      kanombeImg3,
    ],

    shortDescription:
      'Eco-friendly apartment development focusing on energy efficiency and community living.',

    description:
      'Kanombe Eco Apartments integrates green architecture principles with modern urban living. The project promotes environmental responsibility while providing high-quality residential spaces.',

    client: 'Real Estate Investor',
    servicesProvided: [
      'Architectural Design',
      'Green Building Consulting',
      'Construction Management',
    ],

    area: '4,200 m²',

    highlights: [
      'High-efficiency ventilation systems',
      'Community green spaces',
      'Underground parking',
      'Accessibility-friendly design',
    ],

    specifications: [
      { label: 'Structure', value: 'Reinforced concrete frame' },
      { label: 'Floors', value: 'G + 3' },
      { label: 'Parking', value: 'Underground' },
    ],

    seo: {
      title: 'Kanombe Eco Apartments | Sustainable Housing Kigali',
      description:
        'Eco-friendly apartment project in Kanombe, Kigali with green spaces, efficient ventilation, and sustainable architecture.',
    },
  },

  {
    slug: 'birembo-commercial-block',
    title: 'Birembo Commercial Block',
    category: 'Commercial',
    status: 'Completed',
    date: 'August 2022',
    duration: '12 Months',
    location: 'Birembo, Kigali, Rwanda',

    coverImage: biremboCover,
    images: [
      biremboImg1,
      biremboImg2,
      biremboImg3,
    ],

    shortDescription:
      'A modern mixed-use commercial building combining retail and office spaces.',

    description:
      'The Birembo Commercial Block is designed to serve both retail and office users, featuring a modern façade, smart building systems, and efficient circulation.',

    client: 'Commercial Developer',
    servicesProvided: [
      'Architectural Design',
      'Structural Engineering',
      'MEP Design',
    ],

    area: '3,600 m²',

    highlights: [
      'Mixed-use retail and office spaces',
      'Energy-efficient glass façade',
      'Smart surveillance and access control',
      'Ample parking facilities',
    ],

    specifications: [
      { label: 'Façade', value: 'Low-E energy-efficient glass' },
      { label: 'Floors', value: 'Ground + 2' },
      { label: 'Security', value: 'Smart access control system' },
    ],

    seo: {
      title: 'Birembo Commercial Block | Commercial Architecture Kigali',
      description:
        'Modern commercial building in Birembo featuring retail, offices, energy-efficient façade, and smart systems.',
    },
  },

  {
    slug: 'muya-luxury-apartments',
    title: 'Muya Luxury Apartments',
    category: 'Residential / Apartments',
    status: 'Completed',
    date: 'November 2023',
    duration: '16 Months',
    location: 'Kacyiru, Kigali, Rwanda',

    coverImage: muyaCover,
    images: [muyaImg1, muyaImg2, muyaImg3],

    shortDescription:
      'A premium apartment complex offering contemporary living with high-end finishes and panoramic city views.',

    description:
      'Muya Luxury Apartments is a high-end residential development designed for modern urban living. Featuring spacious layouts, premium finishes, and thoughtful amenities, the complex delivers an elevated lifestyle experience in one of Kigali\'s most sought-after neighborhoods.',

    client: 'Private Developer',
    servicesProvided: [
      'Architectural Design',
      'Interior Design',
      'Structural Engineering',
      'Construction Management',
    ],

    area: '5,100 m²',
    budget: 'Confidential',

    highlights: [
      'Premium finishes and fittings throughout',
      'Panoramic city and hillside views',
      'Rooftop terrace and communal lounge',
      'Smart home integration',
      'Secure gated compound with landscaping',
    ],

    specifications: [
      { label: 'Structure', value: 'Reinforced concrete frame' },
      { label: 'Floors', value: 'G + 4' },
      { label: 'Units', value: '24 apartments' },
      { label: 'Smart Systems', value: 'Home automation' },
    ],

    seo: {
      title: 'Muya Luxury Apartments | Premium Housing Kigali',
      description:
        'High-end apartment complex in Kacyiru, Kigali with premium finishes, panoramic views, and smart home systems.',
    },
  },

  {
    slug: 'kanombe-residential-estate',
    title: 'Kanombe Residential Estate',
    category: 'Residential',
    status: 'Completed',
    date: 'March 2024',
    duration: '18 Months',
    location: 'Kanombe, Kigali, Rwanda',

    coverImage: kanombe2Cover,
    images: [kanombe2Img1, kanombe2Img2, kanombe2Img3, kanombe2Img4, kanombe2Img5],

    shortDescription:
      'A large-scale residential estate delivering spacious family homes with modern design and community-focused planning.',

    description:
      'Kanombe Residential Estate is an expansive housing development providing well-designed family homes in a secure, community-oriented environment. The project prioritizes livability, green spaces, and connectivity while meeting the growing demand for quality housing in Kigali.',

    client: 'Real Estate Developer',
    servicesProvided: [
      'Master Planning',
      'Architectural Design',
      'Structural Engineering',
      'Construction Supervision',
    ],

    area: '8,400 m²',
    budget: 'Confidential',

    highlights: [
      'Spacious family homes with private gardens',
      'Secure perimeter with controlled access',
      'Dedicated children\'s play areas and parks',
      'Underground utilities and drainage',
      'Close proximity to schools and amenities',
    ],

    specifications: [
      { label: 'Structure', value: 'Load-bearing masonry & concrete' },
      { label: 'Floors', value: 'Ground + 1' },
      { label: 'Units', value: '32 homes' },
      { label: 'Green Space', value: '30% of total area' },
    ],

    seo: {
      title: 'Kanombe Residential Estate | Family Housing Kigali',
      description:
        'Large-scale family housing estate in Kanombe, Kigali featuring spacious homes, green spaces, and secure community design.',
    },
  },
]
